module.exports = __webpack_public_path__ + "9dd17232b415fcd2ebfdae8902c2255e.png";